/* eslint-disable @typescript-eslint/no-unused-vars */
import { ITopVisAppConfiguration } from "@vega/bootstrap";
import translations from "../app/local-translations.json";

export const version = "0.1";

const redirectUrlPrefix = `${window.location.origin}`;
const paymentWebClientHost = "${VEGA_PAYMENT_URL}";
const paymentServiceHost = "${VEGA_PAYMENT_SERVICE_URL}";

export const appSettings = {
    production: true,
    datacenter: "${VEGA_DATACENTER}",
    stage: "${VEGA_ENVIRONMENT}",
    stripe: {
        publicKeyDe: "${VEGA_STRIPE_PK_DE}",
        publicKeyUs: "${VEGA_STRIPE_PK_US}",
        publicKeyCA: "${VEGA_STRIPE_PK_CA}",
        publicKeyDK: "${VEGA_STRIPE_PK_DK}",
        publicKeyES: "${VEGA_STRIPE_PK_ES}",
        publicKeyNL: "${VEGA_STRIPE_PK_NL}",
        publicKeySE: "${VEGA_STRIPE_PK_SE}",
        publicKeyAU: "${VEGA_STRIPE_PK_AU}",
        publicKeyFR: "${VEGA_STRIPE_PK_FR}",
        publicKeyUK: "${VEGA_STRIPE_PK_UK}",
        publicKeyBE: "${VEGA_STRIPE_PK_BE}",
        publicKeyCH: "${VEGA_STRIPE_PK_CH}",
        publicKeyMX: "${VEGA_STRIPE_PK_MX}",
        publicKeyIT: "${VEGA_STRIPE_PK_IT}"
    }
};

export const appConfiguration: ITopVisAppConfiguration = {
    applicationName: "Payment.WebClient",
    minimumLogLevel: 0,
    errorMode: "detailed",
    canRunOffline: false,
    canRunWithoutToken: true,
    seqConfiguration: {
        use: false
    },
    identityServerConfiguration: {
        use: true,
        apiName: "payment.web",
        apiSecret: "",
        requiredScopes: ["openid", "profile", "email", "payment"],
        url: "${VEGA_IDENTITY_URL}",
        redirectUrl: `${redirectUrlPrefix}/identity/signin-callback.html`,
        silentRedirectUrl: `${redirectUrlPrefix}/identity/silent-callback.html`,
        acrValues: "idp:adfs",
        useCentralDataCenter: false
    },
    relayConfiguration: {
        relayEndpoint: "/api"
    },
    translationConfiguration: {
        use: true,
        modules: ["PAYMENT.WEB", "FRAMEWORK.WEB"],
        defaultLang: "de-DE",
        translations
    },
    userInformationConfiguration: {
        use: false
    },
    authorizationConfiguration: {
        use: false
    },
    lockingConfiguration: {
        use: false
    }
};
